import getters from './getters'
import actions from './actions'
import mutations from './mutations'
import Custom from './custom'

/**
 * This store will be used for all modules of this component
 */
const state = {
  commonObj: {
    hasDropdownLoaded: false,
    serviceTypeList: Custom.serviceTypeList,
    admissionTypeList: Custom.admissionTypeList,
    serviceOfficerComentList: Custom.serviceOfficerComentList,
    outExpenseList: Custom.outExpenseList,
    referList: Custom.referList,
    bankInfoList: [],
    educationList: [],
    nightSleepingList: [],
    observedList: [],
    occupationEconomyList: [],
    roadLivingReasonList: [],
    userPrivilege: [],
    spotList: []
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
